import { Replay, Warning } from "@mui/icons-material"
import robotError from "../../../../assets/GifsAndPlaceholders/robot-error.png"

import { FallbackProps } from "react-error-boundary"

export function ErrorFallbackPage(props: FallbackProps) {

    const { resetErrorBoundary, error } = props


    return (
        <div className="w-full h-full p-10 flex justify-center items-center">

            <div className="w-[70%]">
                <div className="">
                    <img className={"h-40 w-auto"} src={robotError} alt="error" />
                </div>
                <div>
                    <p className="text-6xl font-bold">OOPS!</p>
                </div>
                <div className="">
                    <p className="text-xl">Something went wrong!</p>
                    <p className="text-md mt-2">We're sorry, but it looks like there was an error on our end. Our team has been notified and we're working to fix it as soon as possible.</p>
                    {/* {error.message} */}
                </div>

                <div className="flex gap-2 mt-8">
                    <button onClick={resetErrorBoundary}

                        className={"px-6 bg-cc_brand text-white p-2 rounded-lg border-gray-500 flex justify-center items-center gap-2"}>
                        <Replay /> Reload
                    </button>
                    <button
                        onClick={() => window.location.href = "mailto:support@hosaksham.com?subject=Error Report&body=Please describe the error you encountered:"}
                        className={"px-6 bg-cc_brand text-white p-2 rounded-lg border-gray-500 flex justify-center items-center gap-2"}>
                        <Warning /> Report Problem
                    </button>

                </div>
            </div>

        </div>



    )
}